import { schema } from 'normalizr';

export const currency = new schema.Entity(
  'currencies',
  {},
  {
    idAttribute: item => item.slug,
    processStrategy: item => ({
      name: item.name,
      code: item.code,
      slug: item.slug,
      type: item.type,
    }),
  }
);

export const convertorCurrencies = [currency];
